<template>
  <div>
    <v-container class="content-wrapper" fluid id="institution-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Edit Hosting Institution
          </h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row align="center" class="mb-5">
              <v-col cols="12" md="auto">
                <v-btn
                  v-if="
                    $store.getters.roles === 'super-admin' || $store.getters.roles === 'provider'
                  "
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  @click="back"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to Hosting Institutions
                </v-btn>
                <v-btn
                  v-else
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  :to="{ name: 'Dashboard' }"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to Dashboard
                </v-btn>
              </v-col>
            </v-row>

            <v-tabs v-model="tab" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ $t('basic') }}</v-tab>
              <v-tab>{{ $t('detailed') }}</v-tab>
              <v-tab>{{ $t('classification') }}</v-tab>
              <v-tab>{{ $t('contact') }}</v-tab>
              <v-tab>{{ $t('location') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :value="0">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingBasicInfo
                      :edit="true"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                    ></AddHostingBasicInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="1">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingDetailedInfo
                      :edit="true"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                    ></AddHostingDetailedInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="2">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingClassification
                      :edit="true"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                    ></AddHostingClassification>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="3">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingContactInfo
                      :edit="true"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                    ></AddHostingContactInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="4">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingLocationInfo
                      :edit="true"
                      @tab="changeTab"
                      @updatedChanges="handleUpdatedChanges"
                    ></AddHostingLocationInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>

            <v-card-actions>
              <v-btn
                v-if="$store.getters.roles === 'super-admin'"
                @click="deleteDialog = true"
                depressed
                rounded
                x-large
                color="red"
                class="white--text font-weight-bold pa-5"
              >
                Disable Hosting Institution
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="deleteDialog" max-width="1000px" persistent>
        <v-card
          class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title class="px-0 py-0">
            <v-row class="mx-0 px-2" align="center">
              <v-col cols="11" class="justify-center d-flex">
                <img
                  alt="Logo"
                  width="180"
                  class="rounded-0 text-center"
                  :src="require('@/assets/svg/logo.svg')"
                />
              </v-col>
              <v-col cols="1" class="pl-0">
                <v-btn fab small text @click="deleteDialog = false">
                  <v-icon color="neutral500">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-divider class="custom-divider mt-10"></v-divider>

          <v-card-text class="justify-center d-flex mt-2">
            <v-icon size="150" color="red">$vuetify.icons.deleteCircle</v-icon>
          </v-card-text>
          <v-card-text class="text-center">
            <h3>Disable your Hosting Institution?</h3>
          </v-card-text>
          <v-card-text>
            <p class="text-center pl-16 pr-16">
              Are you sure you want to disable your Hosting Institution? <br />
            </p>
          </v-card-text>
          <v-card-actions>
            <v-row style="width: 100%">
              <v-col cols="6">
                <v-btn
                  @click="deleteDialog = false"
                  block
                  depressed
                  rounded
                  large
                  class="neutral800--text font-weight-bold"
                  color="neutral"
                  outlined
                  >{{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="deleteHosting"
                  block
                  depressed
                  rounded
                  large
                  class="white--text font-weight-bold"
                  color="red"
                  >{{ $t('confirm') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import AddHostingBasicInfo from '../add-hosting/AddHostingBasicInfo.vue';
import AddHostingDetailedInfo from '../add-hosting/AddHostingDetailedInfo.vue';
import AddHostingClassification from '../add-hosting/AddHostingClassification.vue';
import AddHostingContactInfo from '../add-hosting/AddHostingContactInfo.vue';
import AddHostingLocationInfo from '../add-hosting/AddHostingLocationInfo.vue';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'EditHostingInstitution',
  components: {
    AddHostingBasicInfo,
    AddHostingDetailedInfo,
    AddHostingClassification,
    AddHostingContactInfo,
    AddHostingLocationInfo,
  },
  data: () => ({
    tab: null,
    totalTabs: 5,
    deleteDialog: false,
  }),
  methods: {
    changeTab(childTab) {
      this.tab = childTab;
    },
    handleUpdatedChanges(update) {
      this.savedChanges = update;
    },
    deleteHosting() {
      const id = this.$route.params.id;

      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/hosting-institutions/disable/' + id)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('Your Hosting Institution has been disabled successfully.'),
            color: 'primary200',
          });
          sessionStorage.setItem('disabled', true);
        })
        .catch(error => {
          console.log(error);
          EventBus.$emit('snackbar', {
            text: 'Something went wrong. Please try again later',
            color: 'error',
          });
        })
        .finally(
          EventBus.$emit('waiting', false),
          this.$router.push({ name: 'HostingInstitutions' }),
        );
    },
    back() {
      if (this.$route.query.fromTable && this.$store.getters.roles === 'super-admin') {
        const fromTable = this.$route.query;
        this.$router.push({
          name: 'HostingInstitutions',
          query: fromTable,
        });
      } else if (this.$route.query.fromTable && this.$store.getters.roles === 'provider') {
        const fromTable = this.$route.query;
        this.$router.push({
          name: 'HostingInstitutions',
          query: fromTable,
        });
      }
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding-top: 5px;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}
</style>
